var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowPaginationNext(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#40464D",
    d: "M15.295,6.705 C14.905515,7.09448505 14.9051707,7.72585884 15.2942308,8.11576839 L19.17,12 L19.17,12 L15.2942308,15.8842316 C14.9051707,16.2741412 14.905515,16.905515 15.295,17.295 C15.6843607,17.6843607 16.3156393,17.6843607 16.705,17.295 L22,12 L22,12 L16.705,6.705 C16.3156393,6.31563925 15.6843607,6.31563925 15.295,6.705 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40464D",
    d: "M3,11 L20,11 L20,11 L20,13 L3,13 C2.44771525,13 2,12.5522847 2,12 C2,11.4477153 2.44771525,11 3,11 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowPaginationNext);
export default __webpack_public_path__ + "static/media/ic-arrow-pagination-next.aec296924ba47b0688a4c2176d487083.svg";
export { ForwardRef as ReactComponent };